import { render } from "./tender_files.vue?vue&type=template&id=80fac99c"
import script from "./tender_files.vue?vue&type=script&lang=js"
export * from "./tender_files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tender/tabs/tender_files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80fac99c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80fac99c', __exports__)) {
    console.log('reload')
    api.reload('80fac99c', __exports__)
  }
  
  module.hot.accept("./tender_files.vue?vue&type=template&id=80fac99c", () => {
    console.log('re-render')
    api.rerender('80fac99c', render)
  })

}


export default __exports__